import styled from 'styled-components';

export type ChecklistIconProps = {
  color?: 'black' | 'white' | string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export const ChecklistIconView = styled.div<ChecklistIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;
  position: relative;

  &:after {
    content: '';
    width: ${props => (props.size || 24) / 1.5}px;
    height: ${props => (props.size || 24) / 3}px;
    border-left: ${props => props.strokeWidth || 2}px solid ${props => props.color || 'black'};
    border-bottom: ${props => props.strokeWidth || 2}px solid ${props => props.color || 'black'};
    transform: rotate(-45deg) translate(${props => (props.size || 24) / 10}px, ${props => -(props.size || 24) / 10}px);
  }
`;
